import {Space, Steps} from "antd";
import {useCreateLiveEventContext} from "../../context/create-live-event";
import {CreateLiveEventSteps as CreateLiveEventStepsType} from "../../reducers/create-live-event/types";

export function CreateLiveEventSteps() {
  const {state} = useCreateLiveEventContext();
  const mapStepToNumber: Record<CreateLiveEventStepsType, number> = {
    basicForm: 0,
    checkoutForm: 1,
    coverImagesUpload: 2,
    cohost: 3,
    automations: 4,
  };

  return (
    <div>
      <Steps
        // onChange={onStepChange}
        current={mapStepToNumber[state.currentCreateLiveEventStep]}
        size="small"
        direction="vertical"
      >
        <Steps.Step title="Live event information" />
        <Steps.Step
          title="Checkout form"
          disabled={state.currentCreateLiveEventStep === "basicForm"}
        />
        <Steps.Step
          title="Cover image upload"
          disabled={
            state.currentCreateLiveEventStep === "basicForm" ||
            state.currentCreateLiveEventStep === "checkoutForm"
          }
        />
        <Steps.Step
          title="Add co-host"
          disabled={
            state.currentCreateLiveEventStep === "basicForm" ||
            state.currentCreateLiveEventStep === "checkoutForm" ||
            state.currentCreateLiveEventStep === "coverImagesUpload"
          }
        />
        <Steps.Step
          title="Automations"
          disabled={
            state.currentCreateLiveEventStep === "basicForm" ||
            state.currentCreateLiveEventStep === "checkoutForm" ||
            state.currentCreateLiveEventStep === "coverImagesUpload" ||
            state.currentCreateLiveEventStep === "cohost"
          }
        />
      </Steps>
    </div>
  );
}

export function CreateLiveEventFormStepsMobile() {
  const {state} = useCreateLiveEventContext();
  const mapStepToNumber: Record<CreateLiveEventStepsType, number> = {
    basicForm: 0,
    checkoutForm: 1,
    coverImagesUpload: 2,
    cohost: 3,
    automations: 4,
  };
  const mapStepToTitle: Record<CreateLiveEventStepsType, string> = {
    basicForm: "Event information",
    checkoutForm: "Checkout form",
    coverImagesUpload: "Cover image upload",
    cohost: "Add co-host",
    automations: "Automations",
  };
  return (
    <Space size={16} align="center">
      <div
        style={{
          width: "2.4rem",
          height: "2.4rem",
          borderRadius: "3.2rem",
          backgroundColor: "#222222",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {mapStepToNumber[state.currentCreateLiveEventStep] + 1}
      </div>

      <p>{mapStepToTitle[state.currentCreateLiveEventStep]}</p>
    </Space>
  );
}
